module.exports = __webpack_public_path__ + "img/icon_arrow_down.6b1d38a0.svg";